import React from 'react';
import { Stack } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useGetClientContactData } from '@/hooks/useGetClientContactData';
import { useGetRelationshipCompanyContactData } from '@/hooks/useGetRelationshipCompanyContactData';
import { HeaderDetail } from './HeaderDetail';

export const ContactDetails = () => {
	const { clientRow, clientId, isRelationshipCompanyView } = useObjectContext();

	const clientContact = useGetClientContactData({
		clientRow,
		clientId: isRelationshipCompanyView ? null : clientId,
	});
	const companyContact = useGetRelationshipCompanyContactData();
	const { contactEmail, contactPhone } = isRelationshipCompanyView
		? companyContact
		: clientContact;

	if (!contactEmail && !contactPhone) return null;

	return (
		<Stack direction='row' alignItems='center' spacing={3} sx={{ mt: 0.5 }}>
			{contactEmail && <HeaderDetail label='Email'>{contactEmail}</HeaderDetail>}
			{contactPhone && <HeaderDetail label='Phone'>{contactPhone}</HeaderDetail>}
		</Stack>
	);
};
